import { AssignActionPlugin } from './AssignAction';
import { AssignFormActionPlugin } from './AssignFormAction';
import { SendEmailActionPlugin } from './SendEmailAction';

export const defaultActionPlugins = [
  AssignActionPlugin,
  AssignFormActionPlugin,
  SendEmailActionPlugin
];
